import React, { useRef } from 'react';
import classNames from 'classnames';

import Copy from '../Copy';
import Flag from '../Flag';
import SongIndex from '../SongIndex';
import SongExtra from '../SongExtra';
import Delete from '../SongActions/Delete';
import CommentPreview from '../CommentPreview';
import SongImage from 'components/image/SongImage';
import IconButton from 'components/buttons/IconButton';
import WithEventRole from 'components/user/WithEventRole';
import SongArtistNames from 'components/songs/SongArtistNames';
import SelectCheckbox from 'components/context/SelectListContext/SelectCheckbox';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useTimelineSongs } from '../TimelineSongsContext';
import { useSongPlayBar } from 'components/context/SongPlayBarContext';

import { ButtonDecor } from 'vibo-ui/Button';
import { TimelineSongProps } from './interfaces';
import { ButtonIconType, EventUserType } from 'types/enums';

import useDecorStyles from 'components/buttons/IconButton/decorStyle';
import useStyles from './style';

const TimelineSong = <T extends SectionSong>({
  song,
  index,
  className,
  ...rest
}: TimelineSongProps<T>) => {
  const decorClasses = useDecorStyles();
  const classes = useStyles();

  const commentPopupRef = useRef<Nullable<HTMLDivElement>>(null);

  const {
    songsOptions: { songsList },
  } = useTimelineSongs();
  const player = useSongPlayBar();

  return (
    <div
      className={classNames(
        'song',
        {
          [classes.withComment]: !!song.comment,
        },
        classes.song,
        className
      )}
      {...rest}
    >
      <WithEventRole roles={[EventUserType.dj, EventUserType.host]}>
        <>
          <SelectCheckbox id={song._id} />
          <Flag song={song} />
        </>
      </WithEventRole>
      <SongImage
        song={song}
        onClick={song => player?.playSong({ track: song, tracks: songsList })}
        className={classes.songImage}
        isLazy={false}
        label={<Icon icon={IconmoonFont['playFilled-24']} className="playPreview" />}
      />
      <SongIndex index={index + 1} className={classes.songIndex} />
      <SongArtistNames
        song={song}
        onClick={() => player?.playSong({ track: song, tracks: songsList })}
      />
      <WithEventRole roles={[EventUserType.dj, EventUserType.host]}>
        <>
          <Copy song={song} data-gtm-target-id="timeline-section-details-songs-copy-song-title" />
          <CommentPreview song={song} commentPopupRef={commentPopupRef} />
        </>
      </WithEventRole>
      <WithEventRole roles={[EventUserType.guest]} extraCondition={song.canRemove}>
        <Delete
          songs={[song]}
          render={() => (
            <IconButton
              type={ButtonIconType.delete}
              className={classNames(ButtonDecor.danger, decorClasses.highlighted)}
              placement="top"
            />
          )}
        />
      </WithEventRole>
      <SongExtra song={song} commentPopupRef={commentPopupRef} />
    </div>
  );
};

export default TimelineSong;
